/**
 * Settings → One Page App Setup。
 * 打开页面打 STATSIG.COMMON.VIEW，value=settings_one_page_app_setup。
 * GMCC Specials 同一组件 value=one_page_app_setup。
 *
 * 正在用：填 Encompass userID 点 Save；配好后复制 one page app link。
 * 已不算：改输入框。greenbox 没有这项。GMCC 在 Specials 里是同一组件，不另做一套。
 */
export enum SettingsOnePageAppSetupEvent {
    /** 点 Save。value 与 metadata.encompass_userid 相同，为用户填写的 Encompass userID */
    UPDATE = 'ONE_PAGE_APP_SETUP_UPDATE',
    /** 复制 one page app link。value 与 metadata.url 相同，为复制的链接 */
    COPY = 'ONE_PAGE_APP_SETUP_COPY',
}
